import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'

Vue.use(VueI18n)

// Ready translated locale messages
const messages = {
  en: require('./locales/en.json'),
  cs: require('./locales/cs.json'),
  fr: require('./locales/fr.json'),
  pl: require('./locales/pl.json')
}

const language = window.localStorage.getItem('userLanguage')

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: language, // set locale
  fallbackLocale: 'en',
  silentFallbackWarn: true, // suppress warnings
  messages // set locale messages
})

export default i18n

// Moment duration setup
momentDurationFormatSetup(moment)

moment.updateLocale('cs', {
  durationLabelsStandard: {
    S: 'milisekunda',
    SS: 'milisekundy',
    SSS: 'milisekund',
    s: 'sekunda',
    ss: 'sekundy',
    sss: 'sekund',
    m: 'minuta',
    mm: 'minuty',
    mmm: 'minut',
    h: 'hodina',
    hh: 'hodiny',
    hhh: 'hodin',
    d: 'den',
    dd: 'dny',
    ddd: 'dní',
    w: 'týden',
    ww: 'týdny',
    www: 'týdnů',
    M: 'měsíc',
    MM: 'měsíce',
    MMM: 'měsíců',
    y: 'rok',
    yy: 'roky',
    yyy: 'let'
  },
  durationLabelTypes: [
    { type: 'long', string: '___' },
    { type: 'standard', string: '__' },
    { type: 'short', string: '_' }
  ],
  durationPluralKey: function (token, integerValue, decimalValue) {
    if (integerValue >= 5 || integerValue === 0) {
      return token + token + token
    }
    if (integerValue >= 2) {
      return token + token
    }
    return token
  }
})
